import { login } from "./auth/authService";
import ErrorHandler from "./error/errorHandler";
import { APIHandler } from "./handler/apiHandler";
import { SocketService } from "./socket/socketService";
import { currencyCode, language } from "./store/configStore";
import { getQueryParams } from "./utils/queryStringHelper";
import { setSessionStorage } from "./utils/sessionStorageHelper";

/**
 * 세션 스토리지 키 상수
 */
export const STORAGE_KEYS = {
  MACHINE_ID: "machineId",
  USER_INFO: "slotUserInfo",
} as const;

/**
 * 일반 네트워크 클래스
 */
class Network {
  public socketService = new SocketService();
  private apiHandler = new APIHandler();

  async initialize(): Promise<any> {
    await this.auth();
    return await this.apiHandler.reset();
  }

  async auth(): Promise<void> {
    const userInfo = await login();
    if (!userInfo) throw new Error("Login failed");
    // 재연결 시 새로운 소켓 인스턴스 생성
    // this.socketService.init();
  }
}

/**
 * 리플레이 네트워크 클래스
 */
class ReplayNetwork {
  private apiHandler = new APIHandler();
  async initialize(entrySpinId: string): Promise<any> {
    return await this.apiHandler.replayReset(entrySpinId);
  }
}

/**
 * 쿼리 파라미터에서 설정값을 읽어와 스토어에 저장
 */
function parseQueryParams(): void {
  const params = getQueryParams();

  if (typeof params.currencyCode === "string") {
    currencyCode.set(params.currencyCode);
  }

  if (typeof params.language === "string") {
    language.set(params.language);
  }
}

/**
 * 게임 설정 생성
 * @param result - 게임 설정 데이터
 * @returns 게임 설정 객체
 */
function createGameConfig(data: any, params: any): any {
  const currentBetCredit = params.entrySpinId
    ? data.result.betCredit
    : data.result.gameProperties.betMultipliers[0] *
      data.result.machineConfig.numBetSection;

  return {
    ...(params && { entrySpinId: params.entrySpinId }),
    slotInitData: data.result,
    currencyCode: currencyCode.get(),
    lang: language.get(),
    currentBetCredit,
  };
}

/**
 * 네트워크 초기화
 * @param machineId - 머신 ID
 */
async function init(machineId: string): Promise<any> {
  const params = getQueryParams();

  parseQueryParams();
  setSessionStorage(STORAGE_KEYS.MACHINE_ID, machineId);

  try {
    let result: any;

    if (params.entrySpinId && typeof params.entrySpinId === "string") {
      // 리플레이 모드
      const replayNetwork = new ReplayNetwork();
      result = await replayNetwork.initialize(params.entrySpinId);
    } else {
      // 일반 모드
      const normalNetwork = new Network();
      result = await normalNetwork.initialize();
    }

    console.log(result, "reset");

    return createGameConfig(result, params);
  } catch (error) {
    ErrorHandler.send(error);
    throw error;
  }
}

// 외부 스크립트로 사용 시 전역 API 노출
if (typeof window !== "undefined") {
  window.network = {
    init,
  };
}

// UMD 빌드를 위한 기본 export
export { Network, ReplayNetwork };
